import { IPInformation } from 'api';
import { Integration } from 'models';
import { BusinessContactInfo } from 'models/Account';
import {
    ExternalSystemIntegration,
    LabelSummaryWithUsage,
} from 'models/plugin/Plugin';
import { Account } from '../Account';

export enum IconOption {
    House = 'house',
    PointerLight = 'pointerLight',
    PointerDark = 'pointerDark',
}

export interface WidgetConfigResponse {
    account: {
        name: Account['name'];
        geolocation: google.maps.LatLngLiteral | undefined;
        mapSettings: Account['mapSettings'];
        labelsWithUsage?: LabelSummaryWithUsage[];
        showPoweredBy: Account['showPoweredBy'];
    };
    businessContactInfo: BusinessContactInfo;
    ipInfo: IPInformation;
    googleMapsKey: string;
    integration: Partial<Integration>;
    gmbIntegration?: ExternalSystemIntegration;
    publicUrl?: string;
}
